import styled from 'styled-components';

const styledButton = styled.button`

     font-size: 14px;
     font-weight: 500;
     letter-spacing: 2px;
     color: #fff !important;
     padding: 10px 20px;
     transition: background-color 0.1s, color 0.1s;
     text-transform: uppercase;
     border: none;
     -webkit-print-color-adjust: exact;
     background: #582C83;
     white-space: nowrap;

    .purple--btn {
        transition: all .2s ease-in-out;
    }

     &:hover {
         box-shadow: 0 5px 15px #a2a1a1;
         /* background-color: #64389c; */
         color: #fff;
     }
     

`

export default styledButton;